import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { trainerApi } from '../api/trainer';
import type { CreateSessionRequest, UpdateSessionRequest } from '../api/trainer';

export function useTrainerBatches() {
  return useQuery({
    queryKey: queryKeys.trainer.batches(),
    queryFn: async () => {
      const { data } = await trainerApi.listBatches();
      return data ?? [];
    },
  });
}

export function useBatchOverview(batchId: string) {
  return useQuery({
    queryKey: queryKeys.trainer.batchOverview(batchId),
    queryFn: async () => {
      const { data } = await trainerApi.getBatchOverview(batchId);
      return data;
    },
    enabled: !!batchId,
  });
}

export function useCreateSession() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (req: CreateSessionRequest) => trainerApi.createSession(req),
    onSuccess: (_data, req) => {
      // Invalidate overview for the batch that contains this topic's session
      qc.invalidateQueries({ queryKey: queryKeys.trainer.all });
    },
  });
}

export function useUpdateSession() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, req }: { id: string; req: UpdateSessionRequest }) =>
      trainerApi.updateSession(id, req),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.trainer.all });
    },
  });
}

export function useTrainerDashboard() {
  return useQuery({
    queryKey: queryKeys.trainer.dashboard(),
    queryFn: async () => {
      const { data } = await trainerApi.getDashboard();
      return data;
    },
  });
}

